.rotatingIcon {
  width: 24px;
  height: 24px;
  animation: rotate 2s linear infinite;
}

.messageAckFailed {
  align-self: center;
}

.failedIconWrap {
  display: inline-flex;
  align-self: center;
}

.failureTooltip {
  white-space: normal !important;
  overflow-wrap: break-word;
  width: max-content;
  text-align: center;
}

.resendButton {
  align-self: center;
  cursor: pointer;
  opacity: 1;
  
  &.sending {
    opacity: 0.5;
	animation:  rotate 2s linear infinite;
    pointer-events: none;
  }
}

@keyframes rotate {
  from {
	transform: rotate(0deg);
  }
  to {
	transform: rotate(360deg);
  }
}
